// src/components/Especialidades.js

import React from 'react';
import { especialidadesData } from '../data/hospitalData';
import { AlertTriangle, BedDouble, HeartPulse, PhoneCall, CheckCircle } from 'lucide-react';
import '../styles/Especialidades.css';

const iconComponents = {
  AlertTriangle,
  BedDouble,
  HeartPulse,
  PhoneCall,
};

const Especialidades = () => {
  const { titulo, introduccion, serviciosPrincipales, listaEspecialidades } = especialidadesData;

  return (
    <div className="specialties-page-wrapper">
      <div className="specialties-container">
        <header className="specialties-header">
          <h1>{titulo}</h1>
          <p>{introduccion}</p>
        </header>
        
        <section className="main-services-section">
          {serviciosPrincipales.map((servicio) => {
            const IconComponent = iconComponents[servicio.icono];
            return (
              <div key={servicio.titulo} className="service-card">
                <div className="service-card-icon-wrapper">
                  {IconComponent && <IconComponent size={32} />}
                </div>
                <div className="service-card-content">
                  <h2>{servicio.titulo}</h2>
                  <p>{servicio.descripcion}</p>
                </div>
              </div>
            );
          })}
        </section>

        <section className="specialties-list-section">
          <h2 className="section-subtitle">Nuestras Especialidades</h2>
          <ul className="specialties-list-grid">
            {listaEspecialidades.map((especialidad) => (
              <li key={especialidad}>
                <CheckCircle size={18} className="specialty-list-icon" />
                <span>{especialidad}</span>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Especialidades;